import StarIcon from "@mui/icons-material/Star";
import StarBorderIcon from "@mui/icons-material/StarBorder";
import { useNavigate } from "react-router-dom";

interface IPropsCardRating {
    id: string
    cardCode: string
    cardName: string
    comment: string
    score: number
    createdAt: string
}
const CardRating = ({ id, cardCode, cardName, comment, score, createdAt }: IPropsCardRating ) => {
    const navigate = useNavigate();


    const renderStars = (score: number) => {
        const s = Math.max(1, Math.min(5, Math.round(score ?? 0)));
        return (
            <div className="flex items-center gap-0.5">
                {[1, 2, 3, 4, 5].map((i) => (
                    <span key={i} className="text-yellow-400">
                        {i <= s ? <StarIcon fontSize="small" /> : <StarBorderIcon fontSize="small" />}
                    </span>
                ))}
            </div>
        );
    };
    
    return (
        <div key={id} className="bg-white border rounded-lg shadow-sm p-4 flex flex-col justify-between">
            <div>
                <div className="flex items-center justify-between gap-4">
                    <div className="text-sm font-bold text-gray-800 break-words">
                        {cardName ?? `Restaurante ${cardName ?? id}`}
                    </div>
                    <div>{renderStars(score ?? 0)}</div>
                </div>

                {comment && <div className="mt-2 text-sm text-gray-600">{comment}</div>}
            </div>

            <div className="mt-4 flex items-center justify-between gap-3">
                <div className="text-xs text-gray-400">
                    {cardCode ? `ID: ${cardCode}` : null}
                    <div className="mt-1">{createdAt ?? "—"}</div>
                </div>

                <div className="flex items-center gap-2">
                    <button
                        type="button"
                        className="px-3 py-1 bg-primary text-white rounded-md text-sm"
                        onClick={() => navigate(`/on-six/rating/${id}`)}
                        aria-label={`Ver detalle de calificación ${id}`}
                    >
                        Ver todo
                    </button>
                </div>
            </div>
        </div>
    )
}

export default CardRating